import { CircleCheckBig } from "lucide-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "~/components/ui/button";

export const SuccessfulPayment: React.FC = () => {
  const navigate = useNavigate();

  const handleOpenCases = () => {
    navigate("/");
  };

  return (
    <div className="w-full flex">
      <div className="flex flex-col items-center gap-4 w-[512px] mx-auto mt-[56px]">
        <CircleCheckBig className="w-8 h-8 text-green-500" />
        <h3 className="m-0 p-0 text-2xl leading-[32px] font-semibold tracking-[-0.4px]">
          <FormattedMessage
            id="payment.successful"
            defaultMessage="Successful Payment"
          />
        </h3>
        <p className="m-0 p-0 text-sm text-muted-foreground text-center">
          <FormattedMessage
            id="payment.successful.hint"
            defaultMessage="Payment data has been successfully updated, you can continue to use the service."
          />
        </p>
        <Button className="w-full" onClick={handleOpenCases}>
          <FormattedMessage
            id="payment.openCases"
            defaultMessage="Open Cases"
          />
        </Button>
      </div>
    </div>
  );
};
